// Components==============
import Exam from 'components/Exercises/Exam/Exam';
import HighlightExercise from 'components/Exercises/HighlightExercise/HighlightExercise';
import MultipleChoiceExercise from 'components/Exercises/MultipleChoiceExercise/MultipleChoiceExercise';
import SoundGroupExercise from 'components/Exercises/SoundGroupExercise/SoundGroupExercise';
import SoundsExercise from 'components/Exercises/SoundsExercise/SoundsExercise';
import VideoExercise from 'components/Exercises/VideoExercise/VideoExercise';
import Video from 'components/Layout/Menu/components/Dog/components/Video';
import React from 'react';
// =========================

export default function ConditionalExercise({
    exercise,
    setStatus,
}: {
    exercise?: ExerciseEntity;
    setStatus: React.Dispatch<React.SetStateAction<exerciseStatusType>>;
}) {
    if (exercise?.exercise_type === 'highlight') {
        return <HighlightExercise exercise={exercise} setStatus={setStatus} />;
    }

    if (exercise?.exercise_type === 'zinnen') {
        return <Exam exercise={exercise} setStatus={setStatus} />;
    }

    if (exercise?.exercise_type === 'video') {
        return <VideoExercise exercise={exercise} setStatus={setStatus} />;
    }

    if (exercise?.answer_klankgroepen) {
        return <SoundGroupExercise exercise={exercise} setStatus={setStatus} />;
    }

    if (exercise?.answer_klankblokken || exercise?.answer_text) {
        return <SoundsExercise exercise={exercise} setStatus={setStatus} />;
    }

    if (exercise?.answer_button) {
        return (
            <MultipleChoiceExercise exercise={exercise} setStatus={setStatus} />
        );
    }
    return <></>;
}
